import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
// dev环境下写死token
const state = {
  token: debug ? '14908b4f068ee5dab28a' : '',
  // token: '',
  userInfo: debug ? { id: 309658, nickname: 'Amadeus', avatar: 'https://file.qumahudong.com/fw/user/20240325/d1fbdbeb4a6d497d8f89c145ca4de4c8.jpg', openid: 'oDjm45g7dXM30__lPCoUeBgtglBM', mobile: '13822013712' } : {},
  // userInfo: {},
  // subscribe: 0,
  subscribe: debug ? 1 : 0, // 消费者小程序是否关注，1：关注，0：未关注
  address: null,
  location: debug ? { // 北京天安门
    longitude: 116.404,
    latitude: 39.915
  } : null,
  // location: null,
  // qrcode: null,
  qrcode: {},
  jssdkEnabled: false,
  shopOpenId: debug ? 'oDjm45g7dXM30__lPCoUeBgtglBM' : '',
  // shopOpenId: '',
  shopSubscribe: debug ? 1 : 0 // 店铺小程序是否关注，1：关注，0：未关注
  // shopSubscribe: 0
}

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  strict: debug,
  plugins: [
    // createPersistedState({
    //   paths: ['token', 'userInfo', 'jssdkEnabled']
    // })
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js